import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerList: [],
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    addCustomerList: (state, action) => {
      state.customerList = action.payload;
    },
    setNewCustomer: (state, action)=>{
        state.customerList = [...state.customerList,action.payload]
    }

  },
});
export const {
  addCustomerList,
  setNewCustomer
} = customerSlice.actions;
export default customerSlice.reducer;
